import {AccessPointRepository} from "./AccessPointRepository";
import {AccessPoint} from "./AccessPoint";

export class AccessPointRemoteRepository implements AccessPointRepository {
    public async fetchAccessPoints(): Promise<AccessPoint[]> {
        const data = await fetch('https://uji-apps-wifi.s3-eu-west-1.amazonaws.com/ap-coordinates.json')
            .then((res) => res.json())

        const accessPoints: AccessPoint[] = Object.keys(data).map((key: string) => ({
            id: key.split('.')[0],
            cords: {
                lat: data[key][0],
                long: data[key][1],
            },
        }));

        return accessPoints;
    }
}
